function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { GhostButton } from "../GhostButton";
import { cx } from "../../helpers/utils/cx";
const sizes = {
  sm: "p-2 bolt-font-body-s-accent",
  md: "p-3 bolt-font-body-m-accent"
};

/**
 * The generic type `T` allows flexibility in specifying the `id` property type.
 * When `T` is not explicitly provided and inferred from `id`, the `id` type will be a more generic
 * type (`string` or `number`) instead of a specific value.
 */

const alignStyles = {
  left: "justify-start",
  right: "justify-end",
  center: "justify-center"
};
function InnerTab(_ref) {
  let {
    id: key,
    label,
    disabled,
    onClick,
    active,
    size = "md",
    children,
    href,
    render
  } = _ref;
  const handleClick = React.useCallback(() => {
    onClick(key);
  }, [onClick, key]);
  if (render) {
    return render({
      id: key,
      disabled,
      onClick: handleClick,
      active,
      children,
      href,
      size
    });
  }
  return /*#__PURE__*/React.createElement(GhostButton, _extends({
    key: key,
    disabled: disabled,
    onClick: handleClick,
    role: "tab",
    "aria-selected": active,
    as: href ? "a" : "div"
  }, href ? {
    href,
    overrideClassName: "no-underline"
  } : {}), /*#__PURE__*/React.createElement("div", {
    className: cx("text-secondary border-0 border-solid border-b-[0.1875rem] border-b-transparent", sizes[size], active && "text-primary border-b-action-primary", disabled && "text-tertiary")
  }, label || children));
}
export function Tabs(_ref2) {
  let {
    selectedTab,
    children,
    onChange,
    alignment,
    size,
    overrideClassName
  } = _ref2;
  const tabs = React.Children.map(children, child => {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }
    const {
      label,
      id,
      disabled: isDisabled
    } = child.props;
    if (!child.props.id || !child.props.children && !child.props.label) {
      return null;
    }
    const isActive = child.props.id === selectedTab;
    return /*#__PURE__*/React.createElement(InnerTab, _extends({}, child.props, {
      key: id,
      id: id,
      label: label,
      disabled: isDisabled,
      onClick: onChange,
      active: isActive,
      size: size
    }));
  });
  return /*#__PURE__*/React.createElement("div", {
    role: "tablist",
    className: cx("flex border-solid border-0 border-b border-separator", alignStyles[alignment || "left"], overrideClassName)
  }, tabs);
}
function Tab(_props) {
  return null;
}
Tabs.Tab = Tab;